/* esm.sh - applesauce-loaders@5.1.0/dist/helpers/dns-identity */
export * from "/*applesauce-loaders@5.1.0/esnext/dist/helpers/dns-identity.mjs";
